/* eslint-disable react/prop-types, react/no-unstable-nested-components */
import React from 'react';

const NON_UNDOABLE_UPLOAD_STATUSES = ['Cancelled', 'Cancelling', 'CancellationRequested', 'CancellationRecovering'];

const UploadsTabActions = ({ openUndoUploadModal }) => ({
  id: 'action-column',
  Header: <span className="expand-header-offset">Actions</span>,
  Cell: ({ row }) => (
    <div className="form-action-btn-group">
      <button
        className="btn btn-sm btn-danger"
        type="button"
        title="Undo upload"
        disabled={ NON_UNDOABLE_UPLOAD_STATUSES.includes(row.original.documentUploadStatus)
          || row.original.hasFormReviewBegan }
        onClick={ () => openUndoUploadModal(row.original) }
        id={ `undoUploadBtn_${ row.original.id }` }
      >
        <span className="icon icon-stop" />
      </button>
    </div>
  ),
  className: 'col-10p',
});
/* eslint-enable react/prop-types, react/no-unstable-nested-components */

export default UploadsTabActions;
